module.exports = __webpack_public_path__ + "0febfd46b64ea9b53d3921c9e5de68ae.jpg";